import { generateRowsData } from "./generateEstateRowsData";
import { columns } from "./estateColumns";

export const generateEstateTableData = (rawData) => {
    var rowsData = generateRowsData(rawData)
    return {rows: rowsData, columns: columns }
}